

















































export default {
    name: 'CreateOptionsModal',

    setup(props, context) {
        const { $nuxt, $router } = useNuxtApp();

        const createBursary = () => {
            $router.push($nuxt.localePath({ name: 'bursaries-draft' }));
            close();
        };

        const createJob = () => {
            $router.push($nuxt.localePath({ name: 'jobs-draft' }));
            close();
        };

        const close = () => {
            context.emit('close-modal');
        };

        const create = () => {
            selectedOption.value.method();
        };

        const options = [
            {
                label: 'Job',
                icon: 'briefcase-icon',
                method: createJob,
            },
            {
                label: 'Bursary',
                icon: 'academic-cap',
                method: createBursary,
            },
        ];
        const selectedOption = ref(options[0]);
        const loading = ref<boolean>(false);

        return {
            close,
            create,
            loading,
            options,
            selectedOption,
        };
    },
};
